import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useHistory } from "react-router-dom";
import { getConfig } from "@jti/fe-common";
import { Button, PageTitle, TranslationHtmlWrapper, useTranslations } from "@jti/ui";
import ROUTES_PATHS from "../../../constants/routes";
import styles from "./EmailUpdate.module.scss";
const UpdateEmailErrorStatuses = {
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    CONFLICT: 409,
    ALREADY_VERIFIED: 422,
    FALLBACK: -1,
};
const errorsByStatus = {
    [UpdateEmailErrorStatuses.UNAUTHORIZED]: {
        title: "login.update_email.expired.title",
        body: "login.update_email.expired.body",
    },
    [UpdateEmailErrorStatuses.NOT_FOUND]: {
        title: "login.update_email.invalid.title",
        body: _jsx(TranslationHtmlWrapper, { text: "login.update_email.invalid.body", htmlData: [getConfig().CONTACT_US_URL] }),
    },
    [UpdateEmailErrorStatuses.CONFLICT]: {
        title: "login.update_email.already_verified.title",
        body: "login.update_email.already_verified.body",
    },
    [UpdateEmailErrorStatuses.ALREADY_VERIFIED]: {
        title: "login.update_email.already_verified.title",
        body: "login.update_email.already_verified.body",
    },
    [UpdateEmailErrorStatuses.FALLBACK]: {
        title: "login.update_email_failed.title_fallback",
        body: "login.update_email_failed.body_fallback",
    },
};
const getErrorContent = (code) => { var _a; return (_a = errorsByStatus[code]) !== null && _a !== void 0 ? _a : errorsByStatus[UpdateEmailErrorStatuses.FALLBACK]; };
const EmailUpdate = ({ errorStatusCode }) => {
    const history = useHistory();
    const { __ } = useTranslations();
    const handleLoginButtonClick = () => {
        history.push(ROUTES_PATHS.login);
    };
    const errorContent = getErrorContent(errorStatusCode);
    const errorDescription = typeof errorContent.body === "string" ? __(errorContent.body) : errorContent.body;
    return (_jsxs(_Fragment, { children: [_jsx(PageTitle, { className: styles.title, title: __("login.update_email.title"), text: __(errorContent.title) }), _jsxs("div", { className: styles.container, "data-testid": "emailUpdateConfirmationPage", children: [_jsx("p", { children: errorDescription }), _jsx(Button, { className: styles.loginButton, "data-testid": "loginButton", onClick: handleLoginButtonClick, children: __("login.login_button_label") })] })] }));
};
export default EmailUpdate;
